import Vue from 'vue';
import store from './stores/store';

/** Global filters for Vue */

Vue.filter('date', (date: Date | string) => {
  if (!date) { return ''; }
  return new Date(date).toLocaleDateString('fi', {day: '2-digit', month: '2-digit', year: 'numeric'});
});

Vue.filter('currency', (value: string | number) => {
  if (!value) { return ''; }
  const numeric = Number(Math.round(Number(value) * 100) / 100);
  const toComma = (numeric + '').replace('.', ',');
  return `${toComma} €`;
});

Vue.filter('bytes', (value: string | number) => {
  if (!value)  {return ''; }
  const bytes = Number(value);
  const decimals = 2;
  if (bytes === 0) { return '0 Bytes'; }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
});

Vue.filter('ranges', (values: number[]) => {
  const rangeObj: { ranges: string[], currentRange: number[] } = {ranges: [], currentRange: []};

  function format(numbers: number[]) {
    if (numbers.length > 2 ) {
      return `${numbers[0]}-${numbers[numbers.length - 1]}`;
    }
    return numbers.join(', ');
  }

  return [...values].sort((a, b) => a - b).reduce((stored, x, i) => {
    if (i === 0) {
      stored.currentRange.push(x);
    } else {
      if (x === stored.currentRange[stored.currentRange.length - 1] + 1) {
        stored.currentRange.push(x);
      } else {
        stored.ranges.push(format(stored.currentRange));
        stored.currentRange.length = 0;
        stored.currentRange.push(x);
      }
    }

    if (values.length - 1 === i) {
      stored.ranges.push(format(stored.currentRange));
    }
    return stored;
  }, rangeObj ).ranges.join(', ');
});

Vue.filter('fullAddress', (address: string, postalcode?: string, city?: string ) => {
  if (!address) { return ''; }
  let fullAddress = address;
  fullAddress += postalcode && city ? `, ${postalcode} ${city}` : '';
  return fullAddress;
});

Vue.filter('list', (list: string[]) => {
  if (!list) { return ''; }
  return list.filter(Boolean).join(', ');
});
